module.exports = __webpack_public_path__ + "static/media/bottom-tc.75fa7380.png";